import React from 'react'

function Runing_bar() {
  return (
    <div>

<div class="scroll-left ">
<h1 className='pt-2 text-center'>📣 Avail Discount On Our Selected Programs: Get Our Mentor-Led for Flat 50% off! (Valid till Today)  </h1>
</div>
    </div>
  )
}

export default Runing_bar
